import { render, staticRenderFns } from "./EinvoiceSetup.vue?vue&type=template&id=bcabb9e2&scoped=true&"
import script from "./EinvoiceSetup.vue?vue&type=script&lang=js&"
export * from "./EinvoiceSetup.vue?vue&type=script&lang=js&"
import style0 from "./EinvoiceSetup.vue?vue&type=style&index=0&id=bcabb9e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcabb9e2",
  null
  
)

export default component.exports